import { getEmbedConfig } from "@/lib/embed/config";

/** Strict 3- or 6-digit hex colour, e.g. `#f49600` or `#abc`. */
const HEX_COLOR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

/** Canonical MBOA brand accent — the safe fallback when a configured accent is invalid. */
export const DEFAULT_ACCENT = "#f49600";

/**
 * Apply an accent colour to the `--brand` CSS variable.
 *
 * Validates strictly against a hex pattern first: anything else is rejected
 * with no DOM write (prevents CSS injection via the postMessage bridge).
 * Returns whether the colour was applied.
 */
export function applyAccent(color: string): boolean {
  if (!HEX_COLOR.test(color)) {
    return false;
  }
  document.documentElement.style.setProperty("--brand", color);
  return true;
}

/**
 * Reset `--brand` to the configured default accent.
 *
 * Routed through {@link applyAccent} so the configured value is hex-validated
 * (a misconfigured `VITE_EMBED_ACCENT` can't inject CSS); falls back to the
 * canonical brand accent if the configured default is invalid.
 */
export function resetAccent(): void {
  if (!applyAccent(getEmbedConfig().defaultAccent)) {
    applyAccent(DEFAULT_ACCENT);
  }
}
